import { Instance, types, SnapshotOut, SnapshotIn } from 'mobx-state-tree';

export const CompanyModel = types.model({
  name: types.string,
});

export interface ICompanyModel extends Instance<typeof CompanyModel> {}
export interface Company extends SnapshotOut<typeof CompanyModel> {}
export interface CompanyIn extends SnapshotIn<typeof CompanyModel> {}
